import React, { ComponentProps } from 'react';
import { Poppins } from './Poppins';
import { Tooltip } from './Tooltip';
import * as S from './InputLabel.styles';

type InputLabelProps = Omit<ComponentProps<typeof Poppins>, 'ref'> & {
  children: React.ReactNode;
  tooltip?: string;
  charCount?: { value?: string | null; max: number };
};

export const InputLabel: React.FC<InputLabelProps> = ({ children, tooltip, charCount, ...poppinsProps }) => {
  const label = tooltip ? (
    <S.LabelRow>
      <S.StyledInputLabel {...poppinsProps}>{children}</S.StyledInputLabel>
      <Tooltip infoIconStyle={{ transform: 'scale(0.7)', marginTop: '-6px' }} place="right" dataHtml={tooltip} />
    </S.LabelRow>
  ) : (
    <S.StyledInputLabel {...poppinsProps}>{children}</S.StyledInputLabel>
  );

  if (!charCount) return label;

  const count = charCount.value?.length ?? 0;

  return (
    <S.CounterRow>
      {label}
      <S.CharCounter $over={count > charCount.max}>
        {count} / {charCount.max}
      </S.CharCounter>
    </S.CounterRow>
  );
};
